// Product filter logic
export default function productFilters() {
  // Elements
  let productGrids = document.querySelectorAll('.c-product-grid');
  let searchInput = document.querySelector('.c-product-filters__search input');
  let noResults = document.querySelector('.no-search-results');
  let mobileFilterBtn = document.querySelector('.c-product-filters__mobile-btn');
  let mainFilterWrapper = document.querySelector('.c-product-filters');

  const filterByCategoryText =
    document.querySelector('.c-product-filters').dataset.filterText;

  const filterControl = {
    search: {
      term: '',
      active: false,
    },
    category: {
      text: filterByCategoryText,
      active: false,
      isOpen: false,
    },
    mobile: {
      isOpen: (window.innerWidth < 768) ? false : true,
    },
    toggleMobile() {
      this.mobile.isOpen = !this.mobile.isOpen;
    },
    submitSearch() {
      this.search.term = searchInput.value.toLowerCase();
      this.search.active = true;

      filterMaster();
    },
    selectCategory(category) {
      this.category.text = category;
      this.category.active = true;
      this.category.isOpen = false;

      filterMaster();
    },
    clearFilters() {
      this.search.active = false;
      this.search.term = '';
      this.category.active = false;
      this.category.text = filterByCategoryText;

      filterMaster();
    },
  };

  /* Master logic to hide / show grids based on selected filters */
  const filterMaster = () => {
    if (filterControl.search.active && filterControl.category.active) {
      categorySearchLogic();
    } else if (filterControl.search.active) {
      searchLogic();
    } else if (filterControl.category.active) {
      for (let grid of productGrids) {
        if (grid.dataset.id == filterControl.category.text) {
          grid.classList.remove('hidden');
          grid.classList.add('visible');
        } else {
          grid.classList.remove('visible');
          grid.classList.add('hidden');
        }
      }
    } else {
      filterReset();
    }
  };

  const categorySearchLogic = () => {
    let results = false;
    let matchingGrids = [];

    for (let grid of productGrids) {
      if (grid.dataset.id == filterControl.category.text) {
        matchingGrids.push(grid);
      } else {
        grid.classList.remove('visible');
        grid.classList.add('hidden');
      }
    }

    for (let grid of matchingGrids) {
      searchReset(grid);
      const walker = document.createTreeWalker(
        grid,
        NodeFilter.SHOW_TEXT,
        (node) =>
          node.textContent.toLowerCase().indexOf(filterControl.search.term) > -1
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT
      );

      let node;
      while ((node = walker.nextNode())) {
        const card = node.parentElement.closest('.c-card');
        if (card) {
          card.classList.add('searchMatch');
        }
      }

      if (grid.querySelector('.searchMatch')) {
        grid.classList.remove('hidden');
        grid.classList.add('visible');
        grid.classList.add('hasSearchMatch');
        results = true;
      }
    }

    if (results) {
      noResults.classList.remove('active');
    } else {
      noResults.classList.add('active');
    }
  };

  const searchLogic = () => {
    let results = false;

    for (let grid of productGrids) {
      searchReset(grid);
      const walker = document.createTreeWalker(
        grid,
        NodeFilter.SHOW_TEXT,
        (node) =>
          node.textContent.toLowerCase().indexOf(filterControl.search.term) > -1
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT
      );

      let node;
      while ((node = walker.nextNode())) {
        const card = node.parentElement.closest('.c-card');
        if (card) {
          card.classList.add('searchMatch');
        }
      }

      if (grid.querySelector('.searchMatch')) {
        grid.classList.remove('hidden');
        grid.classList.add('visible');
        grid.classList.add('hasSearchMatch');
        results = true;
      } else {
        grid.classList.remove('visible');
        grid.classList.add('hidden');
      }
    }

    if (results) {
      noResults.classList.remove('active');
    } else {
      noResults.classList.add('active');
    }
  };

  const searchReset = (grid) => {
    let currentMatches = grid.querySelectorAll('.searchMatch');

    if (currentMatches) {
      for (let match of currentMatches) {
        match.classList.remove('searchMatch');
      }
    }

    grid.classList.remove('hasSearchMatch');
  };

  const filterReset = () => {
    noResults.classList.remove('active');
    searchInput.value = '';
    for (let grid of productGrids) {
      searchReset(grid);
      let productCount = grid.querySelector(
        '.c-product-grid__products'
      ).childElementCount;
      if (productCount !== 0) {
        grid.classList.remove('hidden');
        grid.classList.add('visible');
      }
    }
  };

  const setMobileState = () => {
    console.log("Calling resize function");

    if (window.innerWidth < 768) {
      if (filterControl.mobile.isOpen) {
       mobileFilterBtn.click();
      }
    } else {
      if (!filterControl.mobile.isOpen) {
        mobileFilterBtn.click();
      }
    }
  }
  window.addEventListener('resize', setMobileState);

  window.addEventListener('scroll', () => {
    if (window.scrollY > 250) {
      mainFilterWrapper.classList.add('sticky');
    } else {
      mainFilterWrapper.classList.remove('sticky');
    }
  });

  return {
    filterControl,
  };
}
